import { Pipe, PipeTransform, inject } from '@angular/core';
import { State } from '../state/state';

@Pipe({
  name: 'username',
  standalone: true,
})
export class UsernamePipe implements PipeTransform {
  readonly state = inject(State);

  transform(id: string | number): string {
    const user = this.state.users.find(i => i.id == id);
    if (!user) {
      return 'Unknow';
    } else {
      return user.fullName;
    }
  }
}
